import { TableSchema } from '../metadata-schema';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';
import { fac_lb_loopbaan } from './fac_lb_loopbaan';
import { dim_lg_lesgroep } from './dim_lg_lesgroep';
import { dim_ll_leerling } from './dim_ll_leerling';
import { dim_vk_vak } from './dim_vk_vak';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { Niveau } from '../enums/Niveau';
import { SoortVakpositie } from '../enums/SoortVakpositie';

export const fac_vkk_vakkeuze: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_vkk_vakkeuze",
	"description": "Definitie voor fact tabel fac_vkk_vakkeuze uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"properties": {
		"vkk_abb_vak": {
			"type": "string",
			"label": "Vak (afk)",
			"category": "Vak",
			"example": "entl, wisA, ..."
		},
		"vkk_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fk_ilt": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"vkk_fk_ilt_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"vkk_fk_ilt_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"vkk_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"vkk_fk_lb": {
			"exclude": [
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"vkk_fk_lb_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"vkk_fk_lb_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"vkk_fk_lg": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_lg_lesgroep uit de CumLaude DWH",
			"type": "object",
			"schema": dim_lg_lesgroep
		},
		"vkk_fk_ll": {
			"exclude": [
				"ll_is_cohortstatus_tot_volledig"
			],
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"vkk_fk_vk": {
			"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vk_vak
		},
		"vkk_fk_vs": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"vkk_fun_is_plaatsing_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-aprilplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 april van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 april wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-augustusplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 augustus van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 augustus wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-decemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 december van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 december wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 februari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 februari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-januariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 januari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 januari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juliplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 juli van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juli wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juniplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 juni van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juni wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-meiplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 mei van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 mei wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-maartplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 maart van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 maart wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-novemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 november van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 november wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 oktober van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 oktober wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_plaatsing_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-septemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 september van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 september wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"vkk_fun_is_vakkeuze_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_is_vakkeuze_peildatum_actueel": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_fun_nm_instroommoment": {
			"type": "string",
			"label": "Instroommoment",
			"filter": false,
			"category": "Doorstroom",
			"example": "T/m 1 oktober, Na 1 oktober, Na 1 november, ...",
			"description": "Het moment binnen het schooljaar waarin de leerling is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 'T/m 1 oktober', anders 'Na' de voorgaande eerste van de maand (oktober t/m juli).\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"vkk_fun_nm_nationaliteit": {
			"type": "string",
			"label": "Nationaliteit",
			"category": "Leerling",
			"grouping": false,
			"exportable": false,
			"example": "Nederlandse, Turkse, ..."
		},
		"vkk_fun_nm_vak_uni": {
			"type": "string",
			"label": "Vak (uniform)",
			"category": "Vak",
			"example": "Engels, wiskunde, ..."
		},
		"vkk_fun_nr_maanden_instroom_na_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 10,
			"label": "Instroommoment",
			"grouping": false,
			"exportable": false,
			"category": "Doorstroom",
			"example": "0 - 10",
			"description": "Het aantal maanden (afgerond naar boven) tussen 1 oktober van dit schooljaar en het moment van instroom, mits deze leerling dit schooljaar is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 0.\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"vkk_is_vrijstelling": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_nm_bron": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_nm_lesgroep": {
			"type": "string",
			"label": "Lesgroep",
			"category": "Vak",
			"example": "1een, h5cnetl, ..."
		},
		"vkk_nm_niveau_vak": {
			"label": "Niveau vak",
			"category": "Vak",
			"example": "VMBO b, PrO, HAVO / VWO, ...",
			"type": "string",
			"schema": Niveau
		},
		"vkk_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Vak",
			"filter": false,
			"grouping": false,
			"example": "2022/2023"
		},
		"vkk_nm_soort_vakpositie": {
			"label": "Soort vakpositie",
			"category": "Vak",
			"searchKeys": [
				"Gemeenschappelijk",
				"Profielvak",
				"Keuzevak"
			],
			"example": "Gemeenschappelijk, Profielvak, Keuzevak, ...",
			"type": "string",
			"schema": SoortVakpositie
		},
		"vkk_nm_vak": {
			"type": "string",
			"label": "Vak",
			"category": "Vak",
			"example": "Engelse taal en literatuur, wiskunde A, ..."
		},
		"vkk_nr_jobrun": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"vkk_nr_leerjaar": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar",
			"category": "Opleiding",
			"example": "1, 2, 3, 4, 5, 6"
		},
		"vkk_nr_leerjaar_vak": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar vak",
			"category": "Vak",
			"example": "1, 2, 3, 4, 5, 6"
		},
		"vkk_nr_leerling": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"vkk_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
